import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const PAGE_SIZE = 50;

export default function TablePagination({ page, pageCount, totalRows, onPageChange }) {
  const { t } = useTranslation();

  if (pageCount <= 1) return null;

  const firstRow = (page - 1) * PAGE_SIZE + 1;
  const lastRow = Math.min(page * PAGE_SIZE, totalRows);

  return (
    <div className="dpi-pagination">
      <span className="dpi-pagination-range">
        {t("admin.insights.pagination.showing", {
          from: firstRow,
          to: lastRow,
          total: totalRows,
        })}
      </span>
      <div className="dpi-pagination-controls">
        <button
          type="button"
          className="dpi-pagination-btn"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label={t("admin.insights.pagination.previous")}
        >
          <ChevronLeft size={15} />
        </button>
        <span className="dpi-pagination-page">
          {t("admin.insights.pagination.pageOf", { page, pageCount })}
        </span>
        <button
          type="button"
          className="dpi-pagination-btn"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= pageCount}
          aria-label={t("admin.insights.pagination.next")}
        >
          <ChevronRight size={15} />
        </button>
      </div>
    </div>
  );
}
